export const COMPONENT_VALUE_TYPES = {
  TEXT: 'TEXT',
  TEXTAREA: 'TEXTAREA',
  ARRAY: 'ARRAY',
  OBJECT: 'OBJECT',
  HTML: 'HTML',
  ICON: 'ICON',
  ICON_SOCIAL: 'ICON_SOCIAL',
  BOOLEAN: 'BOOLEAN',
  ENUM: 'ENUM',
  DATE: 'DATE',
  DATETIME: 'DATETIME',
  WATERFALL_GALLERY: 'WATERFALL_GALLERY',
  RICHTEXT: 'RICHTEXT',
  TINYMCE: 'TINYMCE',
  TEXT_WITH_ICON: 'TEXT_WITH_ICON',
  FUTURESIGHT_CONNECT: 'FUTURESIGHT_CONNECT',
  COLOR_PICKER: 'COLOR_PICKER',
  FLEXIBLE_COLUMN_LAYOUT: 'FLEXIBLE_COLUMN_LAYOUT',
  BACKGROUND_PICKER: 'BACKGROUND_PICKER',
  S3_ASSET_URL: 'S3_ASSET_URL',
  LIVESTREAM_PLAYLIST: 'LIVESTREAM_PLAYLIST',
  LIVESTREAM_CONTROL: 'LIVESTREAM_CONTROL',
  AI_CODE_GENERATOR: 'AI_CODE_GENERATOR',
  INFO: 'INFO',
};

export const TEMPLATE_VALUE_TYPES = {
  ARRAY: 'ARRAY',
  BOOLEAN: 'BOOLEAN',
  DATE: 'DATE',
  DATETIME: 'DATETIME',
  ENUM: 'ENUM',
  STRING: 'STRING',
  S3_ASSET_URL: 'S3_ASSET_URL',
};

export const ROLE_VALUE_TYPES = [
  'EDITOR',
  'APPROVER'
];

export const OTHERS_ROLE_VALUE = [
  'HEADER',
  'FOOTER',
  'BASIC',
  'AIXC_DEPLOY'
];

export const PAGE_STATE_TYPE_OTHERS = {
  DRAFT: 'DRAFT',
  DELETED: 'DELETED',
  DELETE_DECLINED: 'DELETE_DECLINED',
  PENDING_DEPLOY: 'PENDING_DEPLOY',
  SCHEDULED: 'SCHEDULED',
  REMOVED: 'REMOVED'
};

export const PAGE_STATE_TYPES_NEED_APPROVAL = {
  PENDING_DELETE: 'PENDING_DELETE',
  UNDER_REVIEW: 'UNDER_REVIEW',
  PENDING_REMOVAL: 'PENDING_REMOVAL'
};

export const PAGE_STATE_TYPES = {
  ...PAGE_STATE_TYPE_OTHERS,
  ...PAGE_STATE_TYPES_NEED_APPROVAL
};

export const DEPLOYMENT_TYPES = {
  PUBLISH: 'PUBLISH',
  REDEPLOY: 'REDEPLOY',
  WITHDRAW: 'WITHDRAW',
  DELETE: 'DELETE'
};

export const COMPONENT_COLOR_THEMES = [
  'LIGHT',
  'DARK'
];

export const COMPONENT_BACKGROUND_TYPE = [
  'VIDEO',
  'IMAGE'
];

export const REGIONS = [
  'US',
  'CN',
  'AR',
  'AR_EN'
];

export const ENV_DOMAINS = [
  'localhost',
  'https://dev-web-cn.ffau.to/cn/',
  'https://dev-web.ffau.to/us/',
  'https://dev-web.ffau.to/ar/',
  'https://dev-web.ffau.to/ar/en/',
  'https://qa-web-cn.ffau.to/cn/',
  'https://qa-web.ffau.to/us/',
  'https://qa-web.ffau.to/ar/',
  'https://qa-web.ffau.to/ar/en/',
  'https://staging-web-cn.ffau.to/cn/',
  'https://staging-web.ffau.to/us/',
  'https://staging-web.ffau.to/ar/',
  'https://staging-web.ffau.to/ar/en/',
  'https://www.faradayfuturecn.com/cn/',
  'https://www.ff.com/us/',
  'https://www.ff.com/ar/',
  'https://www.ff.com/ar/en/',
  'https://www.aixcrypto.ai/en/',
  'https://www.aixcrypto.ai/cn/',
  'https://www.ffai.com/us/',
  'https://www.ffai.com/cn/'
];

export const VIDEO_SIZE = [
  'REGULAR',
  'LARGE'
];

export const BUTTON_SIZE = [
  'SMALL',
  'LARGE'
];

export const BUTTON_STYLE = [
  'DEFAULT',
  'CUSTOMIZED'
];

export const BUTTON_STYLE_TYPE = [
  'UNDERLINED',
  'DEFAULT'
];

export const EVENT_BUTTON_STYLE_TYPE = [
  'UNDERLINED',
  'TRANSPARENT'
];

export const BUTTON_POSITION = [
  'CENTER',
  'LEFT',
  'RIGHT'
];

export const HORIZONTAL_POSITION = [
  'center',
  'left',
  'right'
];

export const COMPONENT_PARALLAX_SPEED = [
  0,
  100,
  200,
  300,
  400,
  500,
  -100,
  -200,
  -300,
  -400,
  -500
];

export const WATERFALL_GALLERY_IMAGE_SIZES = [
  'SMALL',
  'VERTICAL_MEDIUM',
  'HORIZONTAL_MEDIUM',
  'LARGE'
];

export const TWO_COLUMN_TEXT_LAYOUTS = [
  'LEFT',
  'RIGHT'
];
export const THREE_POSITION_LAYOUTS = [
  'LEFT',
  'CENTRAL',
  'RIGHT'
];

export const TWO_ROW_TEXT_LAYOUTS = [
  'TOP',
  'BOTTOM'
];

export const DIRECTIONS = [
  'UP',
  'DOWN',
  'LEFT',
  'RIGHT',
];

export const ALL_POSITIONS = [
  'TOP',
  'LEFT',
  'RIGHT',
  'BOTTOM',
  'TOP_LEFT',
  'TOP_RIGHT',
  'BOTTOM_LEFT',
  'BOTTOM_RIGHT',
];

export const PERCENTAGES = [
  0,
  10,
  20,
  30,
  40,
  50,
  60,
  70,
  80,
  90,
  100
];

export const PERCENTAGES_NO_ZERO_DESC = [
  100,
  90,
  80,
  70,
  60,
  50,
  40,
  30,
  20,
  10
];

export const HEIGHT_VH = [
  0,
  5,
  10,
  15,
  20,
  25,
  30,
  35,
  40,
  45,
  50,
  55,
  60,
  65,
  70,
  75,
  80,
  85,
  90,
  95,
  100
];

export const BACKGROUND_IMAGE_POSITION = [
  'CENTER CENTER',
  'LEFT TOP',
  'LEFT CENTER',
  'LEFT BOTTOM',
  'RIGHT TOP',
  'RIGHT CENTER',
  'RIGHT BOTTOM',
  'CENTER TOP',
  'CENTER BOTTOM'
];

export const SECTION_INTRO_LAYOUT = [
  'CENTER BOTTOM',
  'LEFT 0',
  'LEFT 20%'
];

export const FANCY_SLIDE_CONTENT_LAYOUT = [
  'TOP CENTER',
  'TOP LEFT',
  'TOP RIGHT',
  'BOTTOM CENTER',
  'BOTTOM LEFT',
  'BOTTOM RIGHT'
];

export const BLOGGING_SECTIONS = [
  'FUTURESIGHT',
  'PRESSROOM'
];

export const BACKGROUND_IMAGE_SCALE = [
  'cover',
  'contain',
  '100%',
  '125%',
  '150%',
  '175%',
  '200%'
];

export const US_ZIP_CODE_LENGTH = 5;

export const COLUMNS_COUNT = [
  1,
  2,
  3
];

export const COLUMNS_HEIGHT = [
  '800px',
  '400px',
  '200px',
  'auto'
]

// Used in columns
export const WIDGET_MAX_WIDTH = [
  '100%',
  '1596px',
  '1500px',
  '1200px'
]

export const FLEX_DIRECTION = [
  'COLUMN',
  'ROW',
];

export const ACCORDION_LAYOUT = [
  '25%/75%',
  '50%/50%',
  '75%/25%'
]

export const ALIGN_ITEMS = [
  'none',
  'baseline',
  'center',
  'flex-end',
  'flex-start',
  'stretch',
];

// TODO: Replace with generic 'FLEX_DIRECTION'
export const FLEXIBLE_COLUMNS_DIRECTION = [
  'Single Row',
  'Single Column'
];

export const FLEXIBLE_COLUMNS_COUNT = [
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8
];

export const FLEXIBLE_COLUMNS_VARIANT_1 = [
  '1' /* 100% */
];

export const FLEXIBLE_COLUMNS_VARIANT_2 = [
  '1:1' /* 50%/50% */,
  '1:2' /* 33.3_%/66.6_% */,
  '2:1' /* 66.6_%/33.3_% */,
  '1:3' /* 25%/75% */,
  '3:1' /* 75%/25% */
];

export const FLEXIBLE_COLUMNS_VARIANT_3 = [
  '1:1:1' /* 33.3%/33.3%/33.3% */,
  '1:3:1' /* 20%/60%/20% */,
  '1:2:2' /* 20%/40%/40% */,
  '2:2:1' /* 40%/40%/20% */
];

export const FLEXIBLE_COLUMNS_VARIANT_4 = [
  '1:1:1:1' /* 25%/25%/25%/25% */,
  '1:2:2:1' /* 16.7%/33.3%/33.3%/16.7% */
];

export const FLEXIBLE_COLUMNS_VARIANTS = [
  ...FLEXIBLE_COLUMNS_VARIANT_1,
  ...FLEXIBLE_COLUMNS_VARIANT_2,
  ...FLEXIBLE_COLUMNS_VARIANT_3,
  ...FLEXIBLE_COLUMNS_VARIANT_4
];

export const BACKGROUND_PICKER_CONTENT_TYPE = [
  'None',
  'Image',
  'Video'
];

export const IMAGE_PADDING_TYPE = [
  'FutureSight Padding',
  'Non-FutureSight Padding'
];

export const PADDING_TYPE = [
  'Default',
  'None'
];

export const BUTTON_TYPE = [
  'UNDERLINE',
  'STYLED',
  'TRANSPARENT'
];

export const IMAGE_DISPLAY_TYPE = [
  'FIXED',
  'ADAPTIVE'
];

export const FIELD_TYPE = [
  'Full Name',
  'First Name',
  'Last Name',
  'Phone Number (CN)',
  'Phone Number (US)',
  'Email',
  'Zip Code (US)',
  'State (US)',
  'Province (CN)',
  'Event Date',
  'Event Time',
  'From Location',
  'To Location'
];

export const FONT_FAMILY_ROBOTO = `Roboto, 'Helvetica Neue', Helvetica, 'Segoe UI', Arial, freesans, sans-serif`;
// font list for component style font list dropdown
export const FONT_FAMILIES = [
  FONT_FAMILY_ROBOTO,
  'Sectra',
  'Montserrat',
];
export const FONT_SIZES = [
  '6',
  '7',
  '7.5',
  '8',
  '9',
  '10',
  '10.5',
  '11',
  '12',
  '13',
  '13.5',
  '14',
  '14.5',
  '15',
  '16',
  '17',
  '18',
  '20',
  '22',
  '24',
  '26',
  '27',
  '28',
  '29',
  '30',
  '32',
  '34',
  '36',
  '38',
  '40',
  '42',
  '44',
  '45',
];
export const FONT_COLORS = [
  'Dark',
  'Light',
  'Brand',
];

export const FONT_POINT_PIXEL = [
  { point: '6', pixel: '8px' },
  { point: '7', pixel: '9px' },
  { point: '7.5', pixel: '10px' },
  { point: '8', pixel: '11px' },
  { point: '9', pixel: '12px' },
  { point: '10', pixel: '13px' },
  { point: '10.5', pixel: '14px' },
  { point: '11', pixel: '15px' },
  { point: '12', pixel: '16px' },
  { point: '13', pixel: '17px' },
  { point: '13.5', pixel: '18px' },
  { point: '14', pixel: '19px' },
  { point: '14.5', pixel: '20px' },
  { point: '15', pixel: '21px' },
  { point: '16', pixel: '22px' },
  { point: '17', pixel: '23px' },
  { point: '18', pixel: '24px' },
  { point: '20', pixel: '26px' },
  { point: '22', pixel: '29px' },
  { point: '24', pixel: '32px' },
  { point: '26', pixel: '35px' },
  { point: '27', pixel: '36px' },
  { point: '28', pixel: '37px' },
  { point: '29', pixel: '38px' },
  { point: '30', pixel: '40px' },
  { point: '32', pixel: '42px' },
  { point: '34', pixel: '45px' },
  { point: '36', pixel: '48px' },
  { point: '38', pixel: '50px' },
  { point: '40', pixel: '53px' },
  { point: '42', pixel: '56px' },
  { point: '44', pixel: '58px' },
  { point: '45', pixel: '60px' },
];

export const COLOR_PALETTES = {
  Brand: '#000000',
  Light: 'white',
  Dark: 'black'
};

export const APP_HANDLERS = [
  'None',
  'Share',
  'Reserve',
  'Reserve Alliance (CN)',
  'Reserve Futurist (CN)',
  'Reserve Standard (CN)',
  'Reserve Ecosystem Product (CN)',
  'Reserve Alliance', // for US
  'Reserve Futurist', // for US
  'FF 91 Subscribe',
  '3D Tour',
  'Configurator',
  'Product Page',
  'Alliance Product Page',
  'Futurist Product Page',
  'Ecosystem Product',
  'Ecosystem Product Preorder',
  'FF 91 Preorder',
  'FF 91 Futurist Preorder (US)',
  'AI Hyper Architecture',
  'All Ability AIHypercar',
  'Preorder Faraday X',
  'Preorder FX Early Access',
  'FX Super One',
  'FX Vehicle Business Ecosystem',
  'FX Co-Creation',
  'Robotics Home',
  'Robotics FF Futurist',
  'Robotics FF Master',
  'Robotics FX Aegis',
  'Robotics FF Futurist Preorder',
  'Robotics FF Master Preorder',
  'Robotics FX Aegis Preorder',
  'Robotics Shop FF Futurist Order',
  'Robotics Shop FX Aegis Order',
  'Robotics Shop FF Master Order',
];

export const FLEX_JUSTIFY_CONTENT_POSITION = [
  'flex-start',
  'center',
  'flex-end'
];

export const zIndex = {
  MENU_BAR: 11,
  SLOT_CONTROL: 12,
  // Stacking on the page editor's canvas (the page is a stacking context of its own, contain: paint, so none of
  // this reaches the editor's panels and dialogs around it):
  // - each section is a layer of its own, so a widget's z-index (a header pinned at 9999) can't cover the editor's
  //   "Add" bars or other sections;
  // - the section being used (pointer on it, or keyboard focus) comes above everything else, so its menus and
  //   drop-downs (a header's mega menu) show in full;
  // - the "+" between sections is above even that one: it reaches a little into the sections on either side, and
  //   the one the pointer is coming from would cover it (it's invisible until hovered);
  // - a section's own controls (gear, labels) sit above its content, whatever z-index that uses.
  EDITOR_SECTION: 0,
  EDITOR_ADD: 2,
  EDITOR_SECTION_ACTIVE: 3,
  EDITOR_ADD_BETWEEN: 4,
  EDITOR_CONTROLS: 2147483000,
  SAVE_AS_VERSION_MODAL: 13
};

export const WEBSOCKET_MSG_ID = {
  DEPLOY_STATE: 'deploy state',
  DEPLOY_PROGRESS: 'deploy progress',
  DEPLOY_ERROR: 'deploy error',
  ASSET_UPLOAD_PROGRESS: 'asset upload progress',
  ASSET_UPLOAD_ERROR: 'asset upload error',

  // for online users who are editing pages
  USERS_ON_EDIT: 'users on edit',
  JOIN_EDIT: 'join edit',
  // an AI app changed a page through the connector (agent API): { pageId, app }
  PAGE_CHANGED_BY_APP: 'page changed by app',

  // for custom widget editing
  WIDGET_LOCK_REQUEST: 'widget lock request',
  WIDGET_LOCK_RELEASE: 'widget lock release',
  WIDGET_LOCK_STATUS: 'widget lock status',
  WIDGET_LOCK_CHANGED: 'widget lock changed',
}

export const S3_ASSET_BROWSER_DEFAULT_OPTIONS = {
  cropEnabled: false,
  outputType: 'jpg', // jpg,png: png isn't supported by fileupload endpoint yet.
  croppers: [
    {
      name: 'mobile',
      description: 'Mobile Screen (0px-600px)',
      aspectRatio: '3 / 8',
    },
    {
      name: 'tablet',
      description: 'Tablet Screen (601px-900px)',
      aspectRatio: '4 / 3',
    },
    {
      name: 'desktop',
      description: 'Desktop Screen (901px-1200+px)',
      aspectRatio: '16 / 9',
    },
  ],
}

export const HIGHLIGHTS_DETAIL_LAYOUT = [
  'TextFirst',
  'ImageFirst',
]

export const HIGHLIGHTS_DETAIL_TEXT_TYPE = [
  'title',
  'subtitle',
  'paragraph',
]

export const SLICK_SLIDE_SPEED_IN_SECONDS = [
  0,
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10
];

// Use genesis locales translation
export const ValidationMessage = {
  PRODUCT_SLIDE_SHOW_S3_ASSET_URL_MOBILE: 'PRODUCT_SLIDE_SHOW_S3_ASSET_URL_MOBILE',
  PRODUCT_SLIDE_SHOW_S3_ASSET_URL_DESKTOP: 'PRODUCT_SLIDE_SHOW_S3_ASSET_URL_DESKTOP',
}

export const TEXT_PROPS_VALIDATION = {
  VIDEO_PLAYER: {
    // allows https or empty string - will use https by default
    pattern: `^(https:)?//.*(mp4|mov)$`,
    message: "The video URL must start with https:// and be one of the following formats: .mp4, .mov"
  },
  LIVESTREAM_VIDEO_PLAYER: {
    pattern: `^(https:)?//(.*(m3u8|mp4|mov)|((www.)?youtube.com.*))$`,
    message: "The video URL must start with https:// and be one of the following formats: .m3u8, .mp4, .mov, youtube"
  },
  PRODUCT_SLIDE_SHOW_S3_ASSET_URL_MOBILE: {
    pattern:  `.*`,
    message: ValidationMessage.PRODUCT_SLIDE_SHOW_S3_ASSET_URL_MOBILE, 
  },
  PRODUCT_SLIDE_SHOW_S3_ASSET_URL_DESKTOP: {
    pattern:  `.*`,
    message: ValidationMessage.PRODUCT_SLIDE_SHOW_S3_ASSET_URL_DESKTOP, 
  },
}

export const SIMPLE_RESERVATION_EMAIL_LANGUAGE = [
  // Be careful when changing these email languages.
  // This data affects the createSimpleReservationHandler in core-api.
  'AR',
  'EN',
];

export const JOBS_OPENINGS_STYLE = [
  'FF',
  'AIXC'
];

export const PAGE_METADATA_KEYS = {
  SCHEMA: 'schema',
}